import { render, staticRenderFns } from "./MediaSuggestionForm.vue?vue&type=template&id=f162cdd6&scoped=true&"
import script from "./MediaSuggestionForm.vue?vue&type=script&lang=js&"
export * from "./MediaSuggestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f162cdd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f162cdd6')) {
      api.createRecord('f162cdd6', component.options)
    } else {
      api.reload('f162cdd6', component.options)
    }
    module.hot.accept("./MediaSuggestionForm.vue?vue&type=template&id=f162cdd6&scoped=true&", function () {
      api.rerender('f162cdd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/landing-page/components/MediaSuggestionForm.vue"
export default component.exports